import React from "react";
import { Helmet } from "react-helmet";
import { useAccuCustomization } from "../../hooks/useAccuCustomization";

export function ApplicationContainer() {
    const accuCustomization = useAccuCustomization();

    if (!accuCustomization) return <></>;
    return (
        <Helmet>
            <link
                rel="apple-touch-icon"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.default}`}
            />
            <link
                rel="apple-touch-icon"
                sizes="58x58"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon58x58}`}
            />
            <link
                rel="apple-touch-icon"
                sizes="76x76"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon76x76}`}
            />
            <link
                rel="apple-touch-icon"
                sizes="152x152"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon152x152}`}
            />
            <link
                rel="apple-touch-icon"
                sizes="167x167"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon167x167}`}
            />
            <link
                rel="apple-touch-icon"
                sizes="180x180"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon180x180}`}
            />
            <link
                rel="icon"
                sizes="128x128"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon128x128}`}
            />
            <link
                rel="icon"
                sizes="192x192"
                href={__styleEnv__ + `${accuCustomization?.mobileIcons?.icon192x192}`}
            />
        </Helmet>
    );
}
